import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV } from "@/data/site";
import { Logo } from "./Brandmark";

export { Logo };

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header data-testid="site-header" className={`sticky top-0 z-50 border-b backdrop-blur-xl transition-[background-color,border-color] ${scrolled || open ? "border-blue-100 bg-[#EAF4FF]/90" : "border-transparent bg-[#EAF4FF]"}`}>
      <div className="wrap flex h-16 items-center justify-between lg:h-[72px]">
        <Logo light={false} />
        <nav aria-label="Menu principale" className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.to.slice(1)}`}
              className={({ isActive }) => `rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${isActive ? "text-blue-700" : "text-slate-700 hover:text-slate-900 hover:bg-white/70"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/preventivo-gratuito" data-testid="header-quote-btn" className="btn-primary hidden !py-2.5 sm:inline-flex">
            Preventivo gratuito <ArrowUpRight className="h-4 w-4" />
          </Link>
          <button type="button" data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-label={open ? "Chiudi menu" : "Apri menu"}
            className="grid h-10 w-10 place-items-center rounded-full border border-slate-300 text-slate-900 lg:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="anim-in border-t border-blue-100 bg-[#EAF4FF] lg:hidden">
          <nav aria-label="Menu mobile" className="wrap flex flex-col py-4">
            <Link to="/" className="border-b border-slate-200 py-3.5 font-display text-lg font-semibold text-slate-900">Home</Link>
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`mobile-nav-${n.to.slice(1)}`} className="border-b border-slate-200 py-3.5 font-display text-lg font-semibold text-slate-900">{n.label}</Link>
            ))}
            <Link to="/preventivo-gratuito" data-testid="mobile-menu-quote-btn" className="btn-primary mt-5">Preventivo gratuito</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
